import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import background from '../assets/Background.png';
import emailjs from '@emailjs/browser';

// Country codes data for phone number selection
const countryCodes = [
  { code: '+1', flag: '🇺🇸', name: 'United States & Canada' },
  { code: '+93', flag: '🇦🇫', name: 'Afghanistan' },
  { code: '+355', flag: '🇦🇱', name: 'Albania' },
  { code: '+213', flag: '🇩🇿', name: 'Algeria' },
  { code: '+376', flag: '🇦🇩', name: 'Andorra' },
  { code: '+244', flag: '🇦🇴', name: 'Angola' },
  { code: '+54', flag: '🇦🇷', name: 'Argentina' },
  { code: '+374', flag: '🇦🇲', name: 'Armenia' },
  { code: '+61', flag: '🇦🇺', name: 'Australia' },
  { code: '+43', flag: '🇦🇹', name: 'Austria' },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaijan' },
  { code: '+973', flag: '🇧🇭', name: 'Bahrain' },
  { code: '+880', flag: '🇧🇩', name: 'Bangladesh' },
  { code: '+375', flag: '🇧🇾', name: 'Belarus' },
  { code: '+32', flag: '🇧🇪', name: 'Belgium' },
  { code: '+501', flag: '🇧🇿', name: 'Belize' },
  { code: '+229', flag: '🇧🇯', name: 'Benin' },
  { code: '+975', flag: '🇧🇹', name: 'Bhutan' },
  { code: '+591', flag: '🇧🇴', name: 'Bolivia' },
  { code: '+387', flag: '🇧🇦', name: 'Bosnia and Herzegovina' },
  { code: '+267', flag: '🇧🇼', name: 'Botswana' },
  { code: '+55', flag: '🇧🇷', name: 'Brazil' },
  { code: '+673', flag: '🇧🇳', name: 'Brunei' },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaria' },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: '+257', flag: '🇧🇮', name: 'Burundi' },
  { code: '+855', flag: '🇰🇭', name: 'Cambodia' },
  { code: '+237', flag: '🇨🇲', name: 'Cameroon' },
  { code: '+238', flag: '🇨🇻', name: 'Cape Verde' },
  { code: '+236', flag: '🇨🇫', name: 'Central African Republic' },
  { code: '+235', flag: '🇹🇩', name: 'Chad' },
  { code: '+56', flag: '🇨🇱', name: 'Chile' },
  { code: '+86', flag: '🇨🇳', name: 'China' },
  { code: '+57', flag: '🇨🇴', name: 'Colombia' },
  { code: '+269', flag: '🇰🇲', name: 'Comoros' },
  { code: '+242', flag: '🇨🇬', name: 'Congo' },
  { code: '+506', flag: '🇨🇷', name: 'Costa Rica' },
  { code: '+385', flag: '🇭🇷', name: 'Croatia' },
  { code: '+53', flag: '🇨🇺', name: 'Cuba' },
  { code: '+357', flag: '🇨🇾', name: 'Cyprus' },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic' },
  { code: '+243', flag: '🇨🇩', name: 'Democratic Republic of Congo' },
  { code: '+45', flag: '🇩🇰', name: 'Denmark' },
  { code: '+253', flag: '🇩🇯', name: 'Djibouti' },
  { code: '+670', flag: '🇹🇱', name: 'East Timor' },
  { code: '+593', flag: '🇪🇨', name: 'Ecuador' },
  { code: '+20', flag: '🇪🇬', name: 'Egypt' },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador' },
  { code: '+240', flag: '🇬🇶', name: 'Equatorial Guinea' },
  { code: '+291', flag: '🇪🇷', name: 'Eritrea' },
  { code: '+372', flag: '🇪🇪', name: 'Estonia' },
  { code: '+268', flag: '🇸🇿', name: 'Eswatini' },
  { code: '+251', flag: '🇪🇹', name: 'Ethiopia' },
  { code: '+679', flag: '🇫🇯', name: 'Fiji' },
  { code: '+358', flag: '🇫🇮', name: 'Finland' },
  { code: '+33', flag: '🇫🇷', name: 'France' },
  { code: '+241', flag: '🇬🇦', name: 'Gabon' },
  { code: '+220', flag: '🇬🇲', name: 'Gambia' },
  { code: '+995', flag: '🇬🇪', name: 'Georgia' },
  { code: '+49', flag: '🇩🇪', name: 'Germany' },
  { code: '+233', flag: '🇬🇭', name: 'Ghana' },
  { code: '+30', flag: '🇬🇷', name: 'Greece' },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala' },
  { code: '+224', flag: '🇬🇳', name: 'Guinea' },
  { code: '+245', flag: '🇬🇼', name: 'Guinea-Bissau' },
  { code: '+592', flag: '🇬🇾', name: 'Guyana' },
  { code: '+509', flag: '🇭🇹', name: 'Haiti' },
  { code: '+504', flag: '🇭🇳', name: 'Honduras' },
  { code: '+852', flag: '🇭🇰', name: 'Hong Kong' },
  { code: '+36', flag: '🇭🇺', name: 'Hungary' },
  { code: '+354', flag: '🇮🇸', name: 'Iceland' },
  { code: '+91', flag: '🇮🇳', name: 'India' },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia' },
  { code: '+98', flag: '🇮🇷', name: 'Iran' },
  { code: '+964', flag: '🇮🇶', name: 'Iraq' },
  { code: '+353', flag: '🇮🇪', name: 'Ireland' },
  { code: '+972', flag: '🇮🇱', name: 'Israel' },
  { code: '+39', flag: '🇮🇹', name: 'Italy' },
  { code: '+81', flag: '🇯🇵', name: 'Japan' },
  { code: '+962', flag: '🇯🇴', name: 'Jordan' },
  { code: '+7', flag: '🇰🇿', name: 'Kazakhstan' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya' },
  { code: '+686', flag: '🇰🇮', name: 'Kiribati' },
  { code: '+82', flag: '🇰🇷', name: 'South Korea' },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait' },
  { code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan' },
  { code: '+856', flag: '🇱🇦', name: 'Laos' },
  { code: '+371', flag: '🇱🇻', name: 'Latvia' },
  { code: '+961', flag: '🇱🇧', name: 'Lebanon' },
  { code: '+266', flag: '🇱🇸', name: 'Lesotho' },
  { code: '+231', flag: '🇱🇷', name: 'Liberia' },
  { code: '+218', flag: '🇱🇾', name: 'Libya' },
  { code: '+423', flag: '🇱🇮', name: 'Liechtenstein' },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania' },
  { code: '+352', flag: '🇱🇺', name: 'Luxembourg' },
  { code: '+853', flag: '🇲🇴', name: 'Macau' },
  { code: '+389', flag: '🇲🇰', name: 'North Macedonia' },
  { code: '+261', flag: '🇲🇬', name: 'Madagascar' },
  { code: '+265', flag: '🇲🇼', name: 'Malawi' },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia' },
  { code: '+960', flag: '🇲🇻', name: 'Maldives' },
  { code: '+223', flag: '🇲🇱', name: 'Mali' },
  { code: '+356', flag: '🇲🇹', name: 'Malta' },
  { code: '+692', flag: '🇲🇭', name: 'Marshall Islands' },
  { code: '+222', flag: '🇲🇷', name: 'Mauritania' },
  { code: '+230', flag: '🇲🇺', name: 'Mauritius' },
  { code: '+52', flag: '🇲🇽', name: 'Mexico' },
  { code: '+691', flag: '🇫🇲', name: 'Micronesia' },
  { code: '+373', flag: '🇲🇩', name: 'Moldova' },
  { code: '+377', flag: '🇲🇨', name: 'Monaco' },
  { code: '+976', flag: '🇲🇳', name: 'Mongolia' },
  { code: '+382', flag: '🇲🇪', name: 'Montenegro' },
  { code: '+212', flag: '🇲🇦', name: 'Morocco' },
  { code: '+258', flag: '🇲🇿', name: 'Mozambique' },
  { code: '+95', flag: '🇲🇲', name: 'Myanmar' },
  { code: '+264', flag: '🇳🇦', name: 'Namibia' },
  { code: '+674', flag: '🇳🇷', name: 'Nauru' },
  { code: '+977', flag: '🇳🇵', name: 'Nepal' },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands' },
  { code: '+64', flag: '🇳🇿', name: 'New Zealand' },
  { code: '+505', flag: '🇳🇮', name: 'Nicaragua' },
  { code: '+227', flag: '🇳🇪', name: 'Niger' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+47', flag: '🇳🇴', name: 'Norway' },
  { code: '+968', flag: '🇴🇲', name: 'Oman' },
  { code: '+92', flag: '🇵🇰', name: 'Pakistan' },
  { code: '+680', flag: '🇵🇼', name: 'Palau' },
  { code: '+970', flag: '🇵🇸', name: 'Palestine' },
  { code: '+507', flag: '🇵🇦', name: 'Panama' },
  { code: '+675', flag: '🇵🇬', name: 'Papua New Guinea' },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay' },
  { code: '+51', flag: '🇵🇪', name: 'Peru' },
  { code: '+63', flag: '🇵🇭', name: 'Philippines' },
  { code: '+48', flag: '🇵🇱', name: 'Poland' },
  { code: '+351', flag: '🇵🇹', name: 'Portugal' },
  { code: '+974', flag: '🇶🇦', name: 'Qatar' },
  { code: '+40', flag: '🇷🇴', name: 'Romania' },
  { code: '+7', flag: '🇷🇺', name: 'Russia' },
  { code: '+250', flag: '🇷🇼', name: 'Rwanda' },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+221', flag: '🇸🇳', name: 'Senegal' },
  { code: '+381', flag: '🇷🇸', name: 'Serbia' },
  { code: '+248', flag: '🇸🇨', name: 'Seychelles' },
  { code: '+232', flag: '🇸🇱', name: 'Sierra Leone' },
  { code: '+65', flag: '🇸🇬', name: 'Singapore' },
  { code: '+421', flag: '🇸🇰', name: 'Slovakia' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia' },
  { code: '+252', flag: '🇸🇴', name: 'Somalia' },
  { code: '+27', flag: '🇿🇦', name: 'South Africa' },
  { code: '+34', flag: '🇪🇸', name: 'Spain' },
  { code: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
  { code: '+249', flag: '🇸🇩', name: 'Sudan' },
  { code: '+597', flag: '🇸🇷', name: 'Suriname' },
  { code: '+46', flag: '🇸🇪', name: 'Sweden' },
  { code: '+41', flag: '🇨🇭', name: 'Switzerland' },
  { code: '+963', flag: '🇸🇾', name: 'Syria' },
  { code: '+886', flag: '🇹🇼', name: 'Taiwan' },
  { code: '+992', flag: '🇹🇯', name: 'Tajikistan' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzania' },
  { code: '+66', flag: '🇹🇭', name: 'Thailand' },
  { code: '+228', flag: '🇹🇬', name: 'Togo' },
  { code: '+676', flag: '🇹🇴', name: 'Tonga' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia' },
  { code: '+90', flag: '🇹🇷', name: 'Turkey' },
  { code: '+993', flag: '🇹🇲', name: 'Turkmenistan' },
  { code: '+256', flag: '🇺🇬', name: 'Uganda' },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine' },
  { code: '+971', flag: '🇦🇪', name: 'United Arab Emirates' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay' },
  { code: '+998', flag: '🇺🇿', name: 'Uzbekistan' },
  { code: '+678', flag: '🇻🇺', name: 'Vanuatu' },
  { code: '+58', flag: '🇻🇪', name: 'Venezuela' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam' },
  { code: '+967', flag: '🇾🇪', name: 'Yemen' },
  { code: '+260', flag: '🇿🇲', name: 'Zambia' },
  { code: '+263', flag: '🇿🇼', name: 'Zimbabwe' }
];

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
`;

const FormContainer = styled.div`
  background-color: white;
  ${'' /* background-image: url(${background}); */}
  background-size: cover;
  background-position: center;
  padding: 40px 60px;
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1001;
`;

const Title = styled.h2`
  font-family: 'Poppins';
font-weight: 600;
font-size: 26px;
line-height: 41px;
letter-spacing: 0%;

  margin-bottom: 24px;
  color: rgba(15, 49, 219, 1);

`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InputRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FullWidthInput = styled.div`
  grid-column: 1 / -1;
`;

const InputLabel = styled.label`
  font-family: Poppins;
font-weight: 500;
font-size: 18px;
line-height: 40px;
letter-spacing: 0%;
vertical-align: middle;
color: rgba(82, 82, 91, 1);


`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PlaceholderTooltip = styled(Tooltip)`
  & .MuiTooltip-tooltip {
    background: none;
    color: #ff4444;
    font-size: 12px;
    font-family: 'Poppins', sans-serif;
    box-shadow: none;
    padding: 0;
    margin: 0;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  & .MuiTooltip-arrow {
    display: none;
  }
`;

const ErrorIcon = styled(ErrorOutlineIcon)`
  color: #ff4444;
  font-size: 8px;
  margin-top: 10px;
`;

const ErrorContainer = styled.div`
  position: absolute;
  right: 12px;
  top: 70%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ErrorText = styled.span`
  color: #ff4444;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  padding-right: 40px;
  border:none;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  background: rgba(226, 236, 252, 1);

  transition: border-color 0.2s;
  display: flex;
  align-items: center;

  &::placeholder {
    color: #999;
    display: flex;
    align-items: center;
  }

  &:focus {
    outline: none;
    border-color: #4862F2;
  }

  &:disabled {
    background-color: #e9ecef;
    cursor: not-allowed;
  }
`;

const SubmitButton = styled.button`
  background: linear-gradient(107.93deg, #4862F2 37.78%, #6B8AFF 100%);
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  width: 200%;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const OTPContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

const OTPInput = styled(Input)`
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 18px;
  padding: 0;
`;

const ResendOTP = styled.button`
  background: none;
  border: none;
  color: #4862F2;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  
  &:disabled {
    color: #999;
    cursor: not-allowed;
    text-decoration: none;
  }
`;

// Country selector styled components
const CountryCodeSelector = styled.div`
  position: relative;
  min-width: 140px;
  z-index: 1001;
`;

const CountryCodeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: none;
  border-radius: 8px 0 0 8px;
  background: rgba(226, 236, 252, 1);
  cursor: pointer;
  font-size: 14px;
  min-width: 140px;
  height: 100%;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  
  &:hover {
    background: rgba(200, 220, 240, 1);
  }
  
  &:disabled {
    background: #e9ecef;
    cursor: not-allowed;
  }
`;

const CountryDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1002;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin-top: 5px;
  min-width: 300px;
  width: max-content;
`;

const CountryOption = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  
  &:hover {
    background: #f5f5f5;
  }
  
  &:first-child {
    border-radius: 8px 8px 0 0;
  }
  
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;

const PhoneInputContainer = styled.div`
  display: flex;
  width: 100%;
`;

const PhoneInput = styled(Input)`
  border-radius: 0 8px 8px 0;
`;

const OTPMessage = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #4862F2;
  background: rgba(72, 98, 242, 0.1);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
  text-align: center;
`;

const ErrorMessage = styled.div`
  color: #ff4444;
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Poppins', sans-serif;
`;

const StyledErrorAlert = styled.div`
  background-color: #fff3f3;
  border: 1px solid #ff4444;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  color: #ff4444;
  font-size: 14px;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const OTPErrorIcon = styled(ErrorOutlineIcon)`
  color: #ff4444;
  font-size: 20px;
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 8px;
  width: 50%;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: 1px solid rgba(68, 97, 242, 0.32);
  border-radius: 24px;
  background: white;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: rgba(82, 82, 91, 1);
  cursor: pointer;
  transition: all 0.2s ease;
  ${'' /* flex: 1; */}
  text-align: center;
  position: relative;
  min-width: fit-content;

  &:hover {
    background: rgba(226, 236, 252, 1);
    border-color: #4862F2;
  }

  input[type="radio"]:checked + & {
    ${'' /* background-color: #4862F2; */}
    color: rgba(15, 49, 219, 1);
    border-color: #4862F2;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(72, 98, 242, 0.2);
  }
`;

const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const RadioAndOTPContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  ${'' /* margin-top: 16px; */}
`;

const OTPWrapper = styled.div`
  width: 50%;
`;

const ButtonWrapper = styled.div`
  width: 50%;
  margin-top: 16px;
`;

const PrivacyMessage = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: rgba(82, 82, 91, 0.7);
  text-align: left;
  margin-top: -20px;
  width: 50%;

  a {
    color: #4862F2;
    text-decoration: none;
    font-weight: 500;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;
const BlankSpace = styled.div`
  width: 500px;
`;

const OverlayForm = ({ onComplete }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    companyName: '',
    areaOfInterest: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    mobile: '',
    companyName: '',
    areaOfInterest: ''
  });

  const [otp, setOtp] = useState(['', '', '', '']);
  const [showOTP, setShowOTP] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [generatedOTP, setGeneratedOTP] = useState('');
  const [otpError, setOtpError] = useState('');
  const [loading, setLoading] = useState(false);

  // Country selection state
  const [selectedCountryCode, setSelectedCountryCode] = useState('+1');
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [countrySearch, setCountrySearch] = useState('');
  const [sessionTimeLeft, setSessionTimeLeft] = useState(null);
  const [typedChars, setTypedChars] = useState('');
  const [lastTypedTime, setLastTypedTime] = useState(0);

  // Check for existing session on component mount
  useEffect(() => {
    const checkExistingSession = () => {
      const userData = localStorage.getItem('userFormData');
      const sessionExpiry = localStorage.getItem('sessionExpiry');
      
      if (userData && sessionExpiry) {
        const now = new Date().getTime();
        const expiryTime = parseInt(sessionExpiry);
        
        if (now < expiryTime) {
          // Session is still valid, populate form and skip to OTP
          const savedData = JSON.parse(userData);
          setFormData({
            name: savedData.name || '',
            email: savedData.email || '',
            mobile: savedData.mobile || '',
            companyName: savedData.companyName || '',
            areaOfInterest: savedData.areaOfInterest || ''
          });
          
          // Set country code if it was saved
          if (savedData.countryCode) {
            setSelectedCountryCode(savedData.countryCode);
          }
          
          // Show OTP section since user is already verified
          setShowOTP(true);
          setOtpSent(true);
          
          console.log('✅ Existing session found, form pre-populated');
        } else {
          // Session expired, clear old data
          localStorage.removeItem('userFormData');
          localStorage.removeItem('sessionExpiry');
          console.log('⏰ Session expired, old data cleared');
        }
      }
    };

    checkExistingSession();
  }, []);

  // Session countdown timer
  useEffect(() => {
    const updateSessionTime = () => {
      const sessionExpiry = localStorage.getItem('sessionExpiry');
      if (sessionExpiry) {
        const now = new Date().getTime();
        const expiryTime = parseInt(sessionExpiry);
        const timeLeft = Math.max(0, expiryTime - now);
        
        if (timeLeft > 0) {
          const minutes = Math.floor(timeLeft / (1000 * 60));
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
          setSessionTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`);
        } else {
          setSessionTimeLeft(null);
          // Session expired, clear data
          localStorage.removeItem('userFormData');
          localStorage.removeItem('sessionExpiry');
          window.location.reload(); // Refresh page to reset form
        }
      }
    };

    const timer = setInterval(updateSessionTime, 1000);
    updateSessionTime(); // Initial call

    return () => clearInterval(timer);
  }, []);

  // Keyboard navigation for country dropdown
  useEffect(() => {
    if (!showCountryDropdown) return;

    const handleKeyDown = (event) => {
      const currentTime = Date.now();
      
      // Reset typed chars if more than 1 second has passed
      if (currentTime - lastTypedTime > 1000) {
        setTypedChars('');
      }
      
      // Only handle alphabetic characters
      if (/^[a-zA-Z]$/.test(event.key)) {
        const newTypedChars = typedChars + event.key.toLowerCase();
        setTypedChars(newTypedChars);
        setLastTypedTime(currentTime);
        
        // Find the first country that starts with the typed characters
        const foundCountry = countryCodes.find(country => 
          country.name.toLowerCase().startsWith(newTypedChars)
        );
        
        if (foundCountry) {
          // Scroll to the found country
          const countryElement = document.querySelector(`[data-country-code="${foundCountry.code}"]`);
          if (countryElement) {
            countryElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showCountryDropdown, typedChars, lastTypedTime]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && !event.target.closest('.country-code-selector')) {
        setShowCountryDropdown(false);
        setCountrySearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showCountryDropdown]);

  const validateName = (name) => {
    if (!name.trim()) {
      return 'Name is required';
    }
    if (name.trim().length < 2) {
      return 'Name should be at least 2 characters';
    }
    if (!/^[a-zA-Z\s]*$/.test(name)) {
      return 'Name should only contain letters and spaces';
    }
    return '';
  };

  const validateEmail = (email) => {
    if (!email.trim()) {
      return 'Email is required';
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const validateMobile = (mobile) => {
    if (!mobile.trim()) {
      return 'Mobile number is required';
    }
    // Allow different lengths for different countries
    if (!/^[0-9\s-]{7,15}$/.test(mobile)) {
      return 'Please enter a valid mobile number';
    }
    return '';
  };

  const validateCompanyName = (companyName) => {
    if (!companyName.trim()) {
      return 'Company name is required';
    }
    if (companyName.trim().length < 2) {
      return 'Company name should be at least 2 characters';
    }
    return '';
  };

  const validateAreaOfInterest = (areaOfInterest) => {
    if (!areaOfInterest) {
      return 'Please select an area of interest';
    }
    return '';
  };

  const isFormValid = () => {
    return Object.keys(formData).every(key => !validateField(key, formData[key]));
  };

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        return validateName(value);
      case 'email':
        return validateEmail(value);
      case 'mobile':
        return validateMobile(value);
      case 'companyName':
        return validateCompanyName(value);
      case 'areaOfInterest':
        return validateAreaOfInterest(value);
      default:
        return '';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('Radio button change:', { name, value });
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Validate the changed field immediately
    let error = '';
    switch (name) {
      case 'name':
        error = validateName(value);
        break;
      case 'email':
        error = validateEmail(value);
        break;
      case 'mobile':
        error = validateMobile(value);
        break;
      case 'companyName':
        error = validateCompanyName(value);
        break;
      case 'areaOfInterest':
        error = validateAreaOfInterest(value);
        break;
    }
    
    setErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const handleOTPChange = (index, value, e) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Handle backspace
    if (e.nativeEvent.inputType === 'deleteContentBackward' && index > 0) {
      const prevInput = document.querySelector(`input[name="otp-${index - 1}"]`);
      if (prevInput) {
        prevInput.focus();
      }
    }
    // Move to next input if a digit was entered
    else if (value && index < 3) {
      const nextInput = document.querySelector(`input[name="otp-${index + 1}"]`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const generateOTP = async () => {
    if (loading) return;
    if (!isFormValid()) {
      // Show all validation errors
      const newErrors = {};
      Object.keys(formData).forEach(key => {
        newErrors[key] = validateField(key, formData[key]);
      });
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setOtpError('');
    setResendTimer(60);

    try {
      // Using the same API from the provided code - removed area of interest
      const apiData = {
        email: formData.email,
        name: formData.name,
        company_name: formData.companyName,
        phone: selectedCountryCode + formData.mobile
      };

      const response = await fetch('https://xfeqaxngaryapybhhfij.supabase.co/functions/v1/send-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiData),
      });

      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          setOtpSent(true);
          setShowOTP(true);
          // Start countdown timer
          const timer = setInterval(() => {
            setResendTimer(prev => {
              if (prev <= 1) {
                clearInterval(timer);
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        } else {
          throw new Error('OTP sending failed');
        }
      } else {
        throw new Error('Failed to send OTP');
      }
    } catch (error) {
      console.error('❌ OTP email failed:', error);
      setOtpError('Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const sendFormDataToAdmin = () => {
    const adminParams = {
      name: formData.name,
      email: formData.email,
      company: formData.companyName,
      phone: formData.mobile,
      area_of_interest: formData.areaOfInterest
    };

    console.log('Sending form data:', adminParams);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID,
        adminParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then((res) => {
        console.log('✅ Form sent to admin', res);
        localStorage.setItem('userFormData', JSON.stringify(formData));
        onComplete();
      })
      .catch((err) => {
        console.error('❌ Form to admin failed', err);
        setOtpError('Error sending form to admin. Please try again.');
      });
  };

  const sendLoginDetailsToAdmin = async () => {
    try {
      // Using the same admin email API from the provided code
      const adminEmailData = {
        to: "support@natoe.ai",
        subject: "Natoe AI - New Lead Submission",
        html: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
            <h2 style="color: #2997FF;">Natoe AI - New Lead Submission</h2>
            <div style="background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
              <h3 style="margin-top: 0; color: #333;">Lead Details</h3>
              <p><strong>Name:</strong> ${formData.name}</p>
              <p><strong>Email:</strong> ${formData.email}</p>
              <p><strong>Phone:</strong> ${selectedCountryCode}${formData.mobile}</p>
              <p><strong>Company:</strong> ${formData.companyName || 'N/A'}</p>
              <p><strong>Area of Interest:</strong> ${formData.areaOfInterest || 'N/A'}</p>
            </div>
            <p style="color: #666; font-size: 14px;">This lead was submitted through the overlay form on the website.</p>
            <p>Best regards,<br>Natoe AI Team</p>
          </div>
        `
      };

      await fetch('https://prodappbackend.natoe.ai/api/admin/send_email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(adminEmailData),
      });

      // Also send to swati as in the provided code
      const swatiEmailData = {
        to: "danita.yerkey@natoe.ai",
        subject: "Natoe AI - New Lead Submission",
        html: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
            <h2 style="color: #2997FF;">Natoe AI - New Lead Submission</h2>
            <div style="background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
              <h3 style="margin-top: 0; color: #333;">Lead Details</h3>
              <p><strong>Name:</strong> ${formData.name}</p>
              <p><strong>Email:</strong> ${formData.email}</p>
              <p><strong>Phone:</strong> ${selectedCountryCode}${formData.mobile}</p>
              <p><strong>Company:</strong> ${formData.companyName || 'N/A'}</p>
              <p><strong>Area of Interest:</strong> ${formData.areaOfInterest || 'N/A'}</p>
            </div>
            <p style="color: #666; font-size: 14px;">This lead was submitted through the overlay form on the website.</p>
            <p>Best regards,<br>Natoe AI Team</p>
          </div>
        `
      };

      await fetch('https://prodappbackend.natoe.ai/api/admin/send_email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(swatiEmailData),
      });

    } catch (error) {
      console.log('Admin notification failed:', error);
    }
  };

  const sendWelcomeEmail = async () => {
    try {
      // Using the same welcome email API from the provided code
      const userEmailData = {
        to: formData.email,
        subject: "Welcome to Natoe AI! 🚀",
        html: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
            <h2 style="color: #2997FF; text-align: center; margin-bottom: 30px;">Welcome to Natoe AI! 🚀</h2>
            
            <p style="font-size: 16px; line-height: 1.6; color: #333;">Hi ${formData.name},</p>
            
            <p style="font-size: 16px; line-height: 1.6; color: #333;">Thanks for reaching out to Natoe AI.</p>
            
            <p style="font-size: 16px; line-height: 1.6; color: #333; margin: 20px 0;">
              We're building the future of radiology - real-time reporting, faster TATs, and always-on AI support. 🚀
            </p>
            
            <p style="font-size: 16px; line-height: 1.6; color: #333;">
              One of our specialists will get in touch with you shortly.
            </p>
            
            <div style="margin: 30px 0; padding: 20px; background-color: #f8f9fa; border-radius: 8px; text-align: center;">
              <p style="margin: 0; font-size: 16px; color: #666;">
                <strong>Talk soon,</strong><br>
                Team Natoe AI
              </p>
            </div>
            
            <div style="text-align: center; margin-top: 30px;">
              <a href="https://www.natoe.ai" style="display: inline-block; padding: 12px 24px; background-color: #2997FF; color: white; text-decoration: none; border-radius: 6px; font-weight: 600;">Visit www.natoe.ai</a>
            </div>
          </div>
        `
      };

      await fetch('https://prodappbackend.natoe.ai/api/admin/send_email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userEmailData),
      });

    } catch (error) {
      console.log('Welcome email failed:', error);
    }
  };

  const sendWelcomeSMS = async () => {
    try {
      // Using the same SMS API from the provided code
      let phoneNumber = formData.mobile.replace(/\D/g, '');
      const countryCode = selectedCountryCode.replace('+', '');
      phoneNumber = countryCode + phoneNumber;
      
      const smsData = {
        to: phoneNumber,
        message: `Hey ${formData.name}, thanks for connecting with Natoe AI! We'll reach out shortly - meanwhile, feel free to explore us at www.natoe.ai`
      };

      await fetch('https://prodappbackend.natoe.ai/api/admin/send_sms', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(smsData),
      });

    } catch (error) {
      console.log('Welcome SMS failed:', error);
    }
  };

  const refreshSession = () => {
    // Extend session by another 30 minutes
    const newExpiry = Date.now() + 30 * 60 * 1000;
    localStorage.setItem('sessionExpiry', newExpiry.toString());
    console.log('🔄 Session refreshed for another 30 minutes');
  };

  const clearSession = () => {
    localStorage.removeItem('userFormData');
    localStorage.removeItem('sessionExpiry');
    setSessionTimeLeft(null);
    setShowOTP(false);
    setOtpSent(false);
    setFormData({
      name: '',
      email: '',
      mobile: '',
      companyName: '',
      areaOfInterest: ''
    });
    setSelectedCountryCode('+1');
    console.log('🗑️ Session cleared');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!showOTP) {
      if (!isFormValid()) {
        return;
      }
      console.log('Form data before OTP:', formData);
      generateOTP();
      return;
    }

    // Verify OTP
    const enteredOTP = otp.join('');
    if (enteredOTP.length !== 4) {
      setOtpError('Please enter the complete 4-digit OTP');
      return;
    }

    setLoading(true);
    setOtpError('');

    try {
      // Using the same API from the provided code
      const verifyData = {
        email: formData.email,
        otp: enteredOTP
      };

      const response = await fetch('https://xfeqaxngaryapybhhfij.supabase.co/functions/v1/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(verifyData),
      });

      if (response.ok) {
        const verifyResult = await response.json();

        if (verifyResult.success) {
          // Store user data and complete immediately
          localStorage.setItem('userFormData', JSON.stringify({
            ...formData,
            phone: selectedCountryCode + formData.mobile,
            countryCode: selectedCountryCode
          }));
          localStorage.setItem('sessionExpiry', (Date.now() + 30 * 60 * 1000).toString());

          // Send notifications in background (don't block UI)
          sendLoginDetailsToAdmin().catch(() => {});
          sendWelcomeEmail().catch(() => {});
          sendWelcomeSMS().catch(() => {}); // SMS for all countries

          onComplete();
        } else {
          setOtpError(verifyResult.message || 'Invalid OTP. Please try again.');
          setLoading(false);
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        setOtpError(errorData.message || 'Invalid OTP. Please try again.');
        setLoading(false);
      }
    } catch (error) {
      console.error('❌ OTP verification error:', error);
      setOtpError('Invalid OTP. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Overlay>
      <FormContainer>
        <Title>Experience Copilot in Action</Title>
        
        {/* Session Status Display */}
        {sessionTimeLeft && (
          <div style={{
            background: 'rgba(226, 236, 252, 0.8)',
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid rgba(72, 98, 242, 0.3)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontFamily: 'Poppins, sans-serif'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '14px', color: '#4862F2' }}>🕒</span>
              <span style={{ fontSize: '14px', color: '#4862F2', fontWeight: '500' }}>
                Active Session: {sessionTimeLeft} remaining
              </span>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                type="button"
                onClick={refreshSession}
                style={{
                  background: '#4862F2',
                  color: 'white',
                  border: 'none',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  fontFamily: 'Poppins, sans-serif'
                }}
              >
                Refresh Session
              </button>
              <button
                type="button"
                onClick={clearSession}
                style={{
                  background: 'transparent',
                  color: '#666',
                  border: '1px solid #ddd',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  fontFamily: 'Poppins, sans-serif'
                }}
              >
                Clear Session
              </button>
            </div>
          </div>
        )}
        
        <Form onSubmit={handleSubmit}>
          <InputRow>
            <InputWrapper>
              <InputLabel>Name</InputLabel>
              <Input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={showOTP}
              />
              {errors.name && (
                <ErrorContainer>
                  <PlaceholderTooltip 
                    title={errors.name} 
                    placement="left"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'transparent',
                          background: 'none',
                          color: '#ff4444'
                        }
                      }
                    }}
                  >
                    <ErrorIcon />
                  </PlaceholderTooltip>
                </ErrorContainer>
              )}
            </InputWrapper>

            <InputWrapper>
              <InputLabel>Mobile Number</InputLabel>
              <PhoneInputContainer>
                <CountryCodeSelector className="country-code-selector">
                  <CountryCodeButton
                    type="button"
                    onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                    disabled={showOTP}
                  >
                    <span style={{ fontSize: '14px', marginRight: '5px' }}>{countryCodes.find(c => c.code === selectedCountryCode)?.flag}</span>
                    <span style={{ fontWeight: '500', marginRight: '10px' }}>{countryCodes.find(c => c.code === selectedCountryCode)?.code}</span>
                    <span style={{ fontSize: '12px', color: '#666' }}>▼</span>
                  </CountryCodeButton>
                  
                  {showCountryDropdown && (
                    <CountryDropdown>
                      <div style={{
                        padding: '8px 12px',
                        borderBottom: '1px solid #eee',
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1
                      }}>
                        <input
                          type="text"
                          placeholder="Search country..."
                          value={countrySearch}
                          onChange={(e) => setCountrySearch(e.target.value)}
                          autoFocus
                          style={{
                            width: '100%',
                            padding: '8px 12px',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontFamily: 'Poppins, sans-serif',
                            outline: 'none',
                            boxSizing: 'border-box'
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      {countryCodes
                        .filter((country) =>
                          !countrySearch ||
                          country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
                          country.code.includes(countrySearch)
                        )
                        .map((country) => (
                        <CountryOption
                          key={country.code}
                          data-country-code={country.code}
                          onClick={() => {
                            setSelectedCountryCode(country.code);
                            setShowCountryDropdown(false);
                            setCountrySearch('');
                          }}
                          style={{
                            backgroundColor: selectedCountryCode === country.code ? 'rgba(226, 236, 252, 0.5)' : 'transparent',
                            fontWeight: selectedCountryCode === country.code ? '600' : '400'
                          }}
                        >
                          <span style={{ fontSize: '16px' }}>{country.flag}</span>
                          <span style={{ fontWeight: '500', minWidth: '50px' }}>{country.code}</span>
                          <span style={{ flex: 1 }}>{country.name}</span>
                        </CountryOption>
                      ))}
                    </CountryDropdown>
                  )}
                </CountryCodeSelector>
                
                <PhoneInput
                  type="tel"
                  name="mobile"
                  placeholder="Enter your mobile number"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  disabled={showOTP}
                />
              </PhoneInputContainer>
              {errors.mobile && (
                <ErrorContainer>
                  <PlaceholderTooltip 
                    title={errors.mobile} 
                    placement="left"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'transparent',
                          background: 'none',
                          color: '#ff4444'
                        }
                      }
                    }}
                  >
                    <ErrorIcon />
                  </PlaceholderTooltip>
                </ErrorContainer>
              )}
            </InputWrapper>
          </InputRow>

          <InputRow>
            <InputWrapper>
              <InputLabel>Company Name</InputLabel>
              <Input
                type="text"
                name="companyName"
                placeholder="Enter your company name"
                value={formData.companyName}
                onChange={handleChange}
                required
                disabled={showOTP}
              />
              {errors.companyName && (
                <ErrorContainer>
                  <PlaceholderTooltip 
                    title={errors.companyName} 
                    placement="left"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'transparent',
                          background: 'none',
                          color: '#ff4444'
                        }
                      }
                    }}
                  >
                    <ErrorIcon />
                  </PlaceholderTooltip>
                </ErrorContainer>
              )}
            </InputWrapper>

            <InputWrapper>
              <InputLabel>Email</InputLabel>
              <Input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={showOTP}
              />
              {errors.email && (
                <ErrorContainer>
                  <PlaceholderTooltip 
                    title={errors.email} 
                    placement="left"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'transparent',
                          background: 'none',
                          color: '#ff4444'
                        }
                      }
                    }}
                  >
                    <ErrorIcon />
                  </PlaceholderTooltip>
                </ErrorContainer>
              )}
            </InputWrapper>
          </InputRow>

          <RadioAndOTPContainer>
            <InputWrapper>
              <InputLabel>Choose Your Role</InputLabel>
              <RadioGroup>
                <RadioInput
                  type="radio"
                  name="areaOfInterest"
                  value="radiologist"
                  id="radiologist"
                  checked={formData.areaOfInterest === 'radiologist'}
                  onChange={handleChange}
                  disabled={showOTP}
                />
                <RadioLabel htmlFor="radiologist">Radiologist</RadioLabel>
                
                <RadioInput
                  type="radio"
                  name="areaOfInterest"
                  value="imaging_center"
                  id="imaging_center"
                  checked={formData.areaOfInterest === 'imaging_center'}
                  onChange={handleChange}
                  disabled={showOTP}
                />
                <RadioLabel htmlFor="imaging_center">Imaging Center</RadioLabel>
                
                <RadioInput
                  type="radio"
                  name="areaOfInterest"
                  value="others"
                  id="others"
                  checked={formData.areaOfInterest === 'others'}
                  onChange={handleChange}
                  disabled={showOTP}
                />
                <RadioLabel htmlFor="others">Others</RadioLabel>
              </RadioGroup>
              {errors.areaOfInterest && (
                <ErrorContainer>
                  <PlaceholderTooltip 
                    title={errors.areaOfInterest} 
                    placement="left"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'transparent',
                          background: 'none',
                          color: '#ff4444'
                        }
                      }
                    }}
                  >
                    <ErrorIcon />
                  </PlaceholderTooltip>
                </ErrorContainer>
              )}
            </InputWrapper>

            {showOTP && (
              <OTPWrapper>
                <p style={{ fontFamily: 'Poppins', fontSize: '14px', color: 'rgba(82, 82, 91, 1)', marginBottom: '8px' }}>Enter OTP sent to your email</p>
                <InputLabel>Enter Verification Code</InputLabel>
                <OTPContainer>
                  {otp.map((digit, index) => (
                    <OTPInput
                      key={index}
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={1}
                      value={digit}
                      name={`otp-${index}`}
                      onChange={(e) => handleOTPChange(index, e.target.value.replace(/[^0-9]/g, ''), e)}
                      required
                    />
                  ))}
                </OTPContainer>
                {otpError && (
                  <StyledErrorAlert>
                    <OTPErrorIcon />
                    {otpError}
                  </StyledErrorAlert>
                )}
                <ResendOTP 
                  onClick={generateOTP} 
                  disabled={resendTimer > 0}
                >
                  {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
                </ResendOTP>
              </OTPWrapper>
            )}
          </RadioAndOTPContainer>
          <InputRow>
          <div className='blank-space'></div>
         

          <ButtonWrapper>
            <SubmitButton type="submit" disabled={loading || (!showOTP && !isFormValid())}>
              {loading ? (showOTP ? 'Verifying...' : 'Sending...') : (showOTP ? 'Verify OTP' : 'Send OTP')}
            </SubmitButton>
          </ButtonWrapper>
          </InputRow>
          <PrivacyMessage>
            Your information will be saved according to our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">privacy policy</a>.
          </PrivacyMessage>
        </Form>
      </FormContainer>
    </Overlay>
  );
};

export default OverlayForm; 